import { NetworkId } from '@/types/network'
import { match } from 'ts-pattern'

export function getApiUrl(chainId: NetworkId) {
	return (
		match(chainId)
			// Spicy
			.with(88882, () => 'https://spicy-staking-api.chiliz.com')
			// Staging
			.with(88883, () => 'https://ccv2-staking-api-staging.chiliz.com')
			// Mainnet
			.with(88888, () => 'https://staking-api.chiliz.com')
			.otherwise(() => import.meta.env.VITE_API_URL)
	)
}
